import { useEffect, useReducer, useState } from "react";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";
import { useDispatch } from "react-redux";
import { modalActions } from "../../storage/modals";

const moneyReducer = (state, action) => {
  const newState = {...state};

  if(action.type === "SET"){
    let value = action.money;

    if(value === ""){
      newState.current = newState.min;
      newState.totalPrice = ((newState.min / newState.step) * newState.price).toFixed(0);

      return newState;
    }

    value = parseInt(value);

    if(isNaN(value)){
      newState.current = newState.min;
      newState.totalPrice = ((newState.min / newState.step) * newState.price).toFixed(0);

      return newState;
    }

    if(value > newState.max){
      newState.current = newState.max;
    }
    else if(value < newState.min){
      newState.current = newState.min;
    }
    else{
      const devide = (value / newState.step).toFixed(0);
      newState.current = parseInt(devide) * newState.step;
    }

    newState.totalPrice = ((newState.current / newState.step) * newState.price).toFixed(0);
    return newState;
  }

  if(action.type === "SET-REAL-MONEY"){
    const minPrice = (newState.min / newState.step) * newState.price;
    const maxPrice = (newState.max / newState.step) * newState.price;
    let value = action.realMoney;

    if(value === ""){
      newState.current = newState.min;
      newState.totalPrice = minPrice;

      return newState;
    }

    value = parseInt(value);

    if(isNaN(value)){
      newState.current = newState.min;
      newState.totalPrice = minPrice;

      return newState;
    }

    if(value > maxPrice){
      newState.current = newState.max;
    }
    else if(value < minPrice){
      newState.current = newState.min;
    }
    else{
      newState.current = value * newState.step;
    }

    newState.totalPrice = ((newState.current / newState.step) * newState.price).toFixed(0);

    return newState;
  }
};

const Money = (props) => {
  const dispatch = useDispatch();
  const [moneyState, dispatchMoney] = useReducer(moneyReducer, {
    min: parseInt(props.currency.min),
    max: parseInt(props.currency.max),
    step: parseInt(props.currency.step),
    price: parseInt(props.currency.price),
    current: parseInt(props.currency.min),
    totalPrice: (props.currency.min / props.currency.step) * props.currency.price
  });

  const [moneyInput, setMoneyInput] = useState(moneyState.current);
  const [priceInput, setPriceInput] = useState(moneyState.totalPrice);

  const moneyHandler = (amount) => {
    dispatchMoney({
      type: 'SET',
      money: amount
    });
  };

  useEffect(() => {
    setMoneyInput(moneyState.current);
    setPriceInput(parseInt(moneyState.totalPrice));
  }, [moneyState])

  useEffect(() => {
    const id = setTimeout(() => {
      dispatchMoney({
        type: 'SET',
        money: moneyInput
      });
    }, 500);
    
    return () => {
      clearTimeout(id);
    }
  }, [moneyInput]);

  useEffect(() => {
    const id = setTimeout(() => {
      dispatchMoney({
        type: 'SET-REAL-MONEY',
        realMoney: priceInput
      });
    }, 500);
    
    return () => {
      clearTimeout(id);
    }
  }, [priceInput]);

  const addToCart = () => {
    dispatch(modalActions.showMoneyCartModal(moneyState.current));
  }

  return (
    <div className="supplement supplement_money" style={{background: `${props.currency.bg} no-repeat center center/cover`}}>
      <img className="supplement-img" src={props.currency.icon} alt="Игровая валюта" />
      <div className="supplement-body">
        <h4 className="supplement-title">Игровая валюта</h4>
        <div className="supplement-description">
          <p className="supplement-p">
            Игровая валюта проекта. Работать больше не надо ;)
          </p>
        </div>
        <div className="money-input">
          <InputRange
            minValue={moneyState.min}
            maxValue={moneyState.max}
            step={moneyState.step}
            value={moneyState.current}
            onChange={moneyHandler}
          />
          <div className="money-inputs-wrapper">
            <div>
            <input type="text" placeholder="валюта" value={moneyInput} onChange={(event) => {setMoneyInput(event.target.value.trim())}}/>
            $
            </div>
            <span className="money-input-info__price">{moneyState.price} ₽ = {moneyState.step} $</span>
            <div>
            <input type="text" placeholder="рубли" value={priceInput} onChange={(event) => {setPriceInput(event.target.value.trim())}}/>
            ₽
            </div>
          </div>
        </div>
        <button type="button" className="supplement-cta" onClick={addToCart}>
          Купить {moneyState.current} $ за {moneyState.totalPrice} ₽
        </button>
      </div>
    </div>
  );
};

export default Money;
